import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { AppContext, AppContextType } from '../../../App';
import { userRole } from '../../../Constants/userRoles';
import { utils } from '../../../helpers/utils';
import { getPublicHomepageSections } from '../../../Services/AdminServices';
import { User } from '../../../Types/User';
import { SectionData } from '../../Pages/ManageHomepageSections/SectionCard';
import PublicChangePasswordForm from '../../Pages/Users/PublicChangePasswordForm';

type PublicHomeNavProps = {
    publicSiteURLActiveMap: { [key: string]: string[] }
};


export const PublicHomeNav: React.FC<PublicHomeNavProps> = ({ publicSiteURLActiveMap }) => {
    const { isLoggedIn, currentUser }: AppContextType = useContext(AppContext);
    function handleToggleNav() {
        $('.nav-trigger').toggleClass('is-active');
        $('.header__content').toggleClass('is-visible');
        $('.wrapper').toggleClass('is-fixed');
    }
    const [navActiveitemName, setnavActiveitemName] = useState<string>('');
    const [renderTrigger, setRenderTrigger] = useState<number>(0);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const isInitilized = useRef<boolean>(false);
    const isMenuExpended = useRef<boolean>(false);
    const currentCategory = useRef<string | null>(null);
    const timerId = useRef<number>(0);

    const currLocation = useLocation();
    const navActiveClassName = 'nav__current';

    const [currUser, setCurrUser] = useState<User | null>(utils.getUserFromLocalToken() as (User | null));
    const hasDashboard: boolean | undefined = currUser?.Roles?.includes(userRole.Administrator) || currUser?.Roles?.includes(userRole['RSA Staff']) ||
     currUser?.Roles?.includes(userRole['Employment Coordinator']) || currUser?.Roles?.includes(userRole['Coordinator Supervisor']);

    useEffect(() => {
        const currPathName = currLocation.pathname;
        Object.keys(publicSiteURLActiveMap).forEach((key, index) => {
            let tempResult: boolean = false;
            publicSiteURLActiveMap[key].forEach((item) => {
                if (currPathName === item && navActiveitemName === '') {
                    setnavActiveitemName(key);
                }
            });
        });
    }, []);

    const [sectionData, setSectionData] = useState<SectionData[]>([]);

    useEffect(() => {
        getPublicHomepageSections(false).then((response) => {
            if (response && response.data) {
                let data = (response.data as any).sections as SectionData[];
                setSectionData(data);
            } else {
                throw new Error('Unable to load sections data from server.');
            }
        });
    }, []);

    const handleLogout = () => {
        utils.clearLocalToken();
        setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_VIRTUAL_DIRECTORY}`
        }, 200);
    }

    useEffect(() => {
        if (!isInitilized.current) {
            isInitilized.current = true;

            // $('.nav').on('click', '.has-dropdown a', function (event) {
            //     let currentWidth = window.innerWidth;
            //     if (currentWidth < 1024) {
            //         var $this = $(this);
            //         $this.siblings('ul').stop().slideToggle().parent().toggleClass('is-expanded');
            //         event.preventDefault();
            //     }
            // });
        }
    });

    const handleClick = (event: React.MouseEvent, itemName: string): void => {
        let currentWidth = window.innerWidth;
        if (currentWidth < 1024) {
            handleFocus(event, itemName);
        }
    }

    const handleFocus = (event: React.FocusEvent | React.MouseEvent, itemName: string): void => {
        if (isMenuExpended.current !== true) {
            const elementTarget = document.getElementById(`${itemName}-link`) as HTMLElement;
            elementTarget.classList.add('active');
            isMenuExpended.current = true;
            setRenderTrigger((previousNumber) => { return previousNumber + 1; });
            currentCategory.current = itemName;
        } else {
            if (timerId.current != 0) {
                if (currentCategory.current === itemName) {
                    // under same sub-menu
                    window.clearTimeout(timerId.current);
                }
                else {
                    // focus changed to another nav menu
                    window.clearTimeout(timerId.current);
                    // de-active privious active nav menu
                    const oldNavElement = document.getElementById(`${itemName}-link`) as HTMLElement;
                    oldNavElement.classList.remove('active');
                    const newNavElement = document.getElementById(`${itemName}-link`) as HTMLElement;
                    newNavElement.classList.add('active');
                    isMenuExpended.current = true;
                    setRenderTrigger((previousNumber) => { return previousNumber + 1; });
                    currentCategory.current = itemName;
                }
            }
        }
    }

    const handleBlur = (event: React.FocusEvent | React.MouseEvent, itemName: string): void => {
        let timeoutTime = 100;
        console.log(event.type);
        if (event.type === 'mouseleave') {
            timeoutTime = 750;
        }
        if (isMenuExpended.current) {
            timerId.current = window.setTimeout(() => {
                isMenuExpended.current = false;
                setRenderTrigger((previousNumber) => { return previousNumber + 1; });
                currentCategory.current = null;
                const oldNavElement = document.getElementById(`${itemName}-link`) as HTMLElement;
                oldNavElement.classList.remove('active');
            }, timeoutTime);
        }
    }


    return (<>
        <header className="header">
            <div className="shell">
                <div className="header__inner" style={{ fontSize: '1.8rem' }}>
                    <a href={`${process.env.REACT_APP_VIRTUAL_DIRECTORY}`} className="logo header__logo highlight-on-focus">
                        <img src={`${process.env.REACT_APP_VIRTUAL_DIRECTORY}/assets/images/svg/logo.svg`} alt="DDS Home Link" width="168" height="168" />
                    </a>

                    <a href="#" className="nav-trigger" title="Nav toggle" onClick={handleToggleNav}>
                        <span></span>

                        <span></span>

                        <span></span>
                    </a>

                    <div className="header__content">
                        <nav className="nav header__nav" style={{ fontSize: '2.3rem' }}>
                            <ul>
                                <li className={navActiveitemName === 'Home' ? navActiveClassName : ''}>
                                    <Link to="/" className='public-site'>Home</Link>
                                </li>

                                <li
                                    id="explore-link"
                                    className={navActiveitemName === 'Explore' ? navActiveClassName + ' has-dropdown' : 'has-dropdown'}

                                >
                                    <a
                                        onClick={(e) => { handleClick(e, 'explore') }}
                                        aria-expanded={isMenuExpended.current}
                                        onFocus={(e) => { handleFocus(e, 'explore') }}
                                        onMouseEnter={(e) => { handleFocus(e, 'explore') }}
                                        onBlur={(e) => { handleBlur(e, 'explore') }}
                                        onMouseLeave={(e) => { handleBlur(e, 'explore') }}
                                        href="#" className='public-site'>Explore</a>

                                    <ul style={{ minWidth: '47rem', textAlign: 'left' }}>
                                        {
                                            sectionData && sectionData.length > 0 &&
                                            sectionData.map((item, index) => {
                                                return (<li key={index}>
                                                    <Link className='public-site' to="#" /*to={item.isHtmlContent ? `/pages/${item.url}` :`/${item.url}` }*/
                                                        onClick={(e)=>window.location.href=item.isHtmlContent ? `${process.env.REACT_APP_VIRTUAL_DIRECTORY}/pages/${item.url}` :`${process.env.REACT_APP_VIRTUAL_DIRECTORY}/${item.url}` }
                                                        onFocus={(e) => { handleFocus(e, 'explore') }}
                                                        onMouseEnter={(e) => { handleFocus(e, 'explore') }}
                                                        onBlur={(e) => { handleBlur(e, 'explore') }}
                                                        onMouseLeave={(e) => { handleBlur(e, 'explore') }}
                                                    >{item.title}</Link>
                                                </li>);
                                            })
                                        }
                                    </ul>
                                </li>

                                <li className={navActiveitemName === 'About' ? navActiveClassName : ''}>
                                    <Link to="/about" className='public-site'>About</Link>
                                </li>

                                <li className={navActiveitemName === 'Contact' ? navActiveClassName : ''}>
                                    <Link to="/contact" className='public-site'>Contact</Link>
                                </li>
                            </ul>
                        </nav>
                        {
                            isLoggedIn && <span className='user-name-tag'>
                                <span><Icon name='user' />{currentUser?.FullName}</span>
                                {
                                    hasDashboard &&
                                    <Link className='highlight-on-focus ml-2' to="/dashboard">Dashboard <Icon name='dashboard' /></Link>
                                }
                                {
                                    currentUser?.Roles?.includes(userRole.Counselor) &&
                                    <Button type='button' onClick={()=>{setIsModalOpen(true)}} className='public-change-password-link'><Icon name='edit'></Icon>Change Password</Button>
                                }
                                <Link className='highlight-on-focus ml-2' to="/" onClick={() => { handleLogout() }}>Sign out <Icon name='sign-out' /></Link>
                            </span>
                        }
                        {
                            !isLoggedIn && <Link to="/login" className="btn btn-default btn-danger header__button public-site" style={{ backgroundColor:'#D00104',color: 'white' }}>Login</Link>
                        }
                    </div>
                </div>
            </div>
            <Modal
                dimmer={"blurring"}
                open={isModalOpen}
                onClose={() => { setIsModalOpen(false) }}
            >
                <Modal.Header style={{fontSize:'22px'}}>Change Password</Modal.Header>
                <Modal.Content>
                    <PublicChangePasswordForm
                        closePopup={()=>{setIsModalOpen(false);}}
                    />
                </Modal.Content>
            </Modal>
        </header>
    </>);
}